import { render, staticRenderFns } from "./RemoveFromTails.vue?vue&type=template&id=ec51b814&"
import script from "./RemoveFromTails.vue?vue&type=script&lang=js&"
export * from "./RemoveFromTails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports